import Companies from '@pages/Companies.vue'
import ViewCompany from '@pages/ViewCompany.vue'

import ManageCompanyProfile from '@pages/company/ManageCompanyProfile.vue'
import ManageCompanyUsers from '@pages/company/ManageCompanyUsers.vue'
import ManageCompanyReports from '@pages/company/ManageCompanyReports.vue'
import ManageCompanyRLS from '@pages/company/ManageCompanyRLS.vue'
import ManageCompanyCashCall from '@pages/company/ManageCompanyCashCall.vue'
import ManageCompanyBilling from '@pages/company/ManageCompanyBilling.vue'


const permissions = [
  {
    role: 'Guest',
    access: false,
    redirect: 'Home'
  },
  {
    role: 'Member',
    access: false,
    redirect: 'Dashboard'
  },
  {
    role: 'Company',
    access: false,
    redirect: 'Dashboard'
  }
]

export default [
  {
    path: '/companies',
    name: 'Companies',
    component: Companies,
    meta: {
      permissions: permissions
    }
  },
  {
    path: '/companies',
    name: 'ViewCompany',
    component: ViewCompany,
    redirect: {
      name: 'ManageCompanyProfile'
    },
    children: [
      {
        path: ':id',
        name: 'ManageCompanyProfile',
        component: ManageCompanyProfile,
        meta: {
          permissions: permissions
        }
      },
      {
        path: ':id/users',
        name: 'ManageCompanyUsers',
        component: ManageCompanyUsers,
        meta: {
          permissions: permissions
        }
      },
      {
        path: ':id/reports',
        name: 'ManageCompanyReports',
        component: ManageCompanyReports,
        meta: {
          permissions: permissions
        }
      },
      {
        path: ':id/rls',
        name: 'ManageCompanyRLS',
        component: ManageCompanyRLS,
        meta: {
          permissions: permissions
        }
      },
      {
        path: ':id/cashcall',
        name: 'ManageCompanyCashCall',
        component: ManageCompanyCashCall,
        meta: {
          permissions: permissions
        }
      },
      {
        path: ':id/billing',
        name: 'ManageCompanyBilling',
        component: ManageCompanyBilling,
        meta: {
          permissions: permissions
        },
        beforeEnter(to, from, next) {
          if (process.env.VUE_APP_ENABLE_BILLING_MANAGEMENT === '1') {
            next()
          } else {
            next({ name: 'ManageCompanyProfile', params: { id: to.params.id } })
          }
        }
      }
    ]
  }
]
